/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/naming-convention */
const START_TEXT = 'xcbvar00';
const vv_null = 0x00;
const vv_bool_true = 0x01;
const vv_bool_false = 0x02;
const vv_int8 = 0x10;
const vv_int16 = 0x20;
const vv_int32 = 0x30;
const vv_int64 = 0x40;
const vv_uint8 = 0x50;
const vv_uint16 = 0x60;
const vv_uint32 = 0x70;
const vv_uint64 = 0x80;

const vv_array = 0xa0;
const vv_data = 0xb0;
const vv_string = 0xc0;
const vv_dict = 0xd0;
const vv_float = 0xe0;
const vv_double = 0xf0;
const LENGTH_MASK = 0x0f;
const TYPE_MASK = 0xf0;

function read_integer_value(data: any[], index: number, byte_length: number) {
  let idx = index;
  let r = 0;
  switch (byte_length) {
    case Uint8Array.BYTES_PER_ELEMENT:
      r |= data[idx];
      break;
    case Uint16Array.BYTES_PER_ELEMENT:
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      break;
    case Uint32Array.BYTES_PER_ELEMENT:
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      break;
    case BigUint64Array.BYTES_PER_ELEMENT:
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      r <<= 8;
      r |= data[idx++];
      break;
    default:
      return false;
  }
  return r;
}

function deserialize_variant(
  refTable: { [x: string]: number },
  objCount: number,
  objId: number,
  data: any,
  length: number,
  refElelen: number,
) {
  let index = 0;
  let objType = -1;
  let objLength = 0;

  if (objId >= objCount) {
    return vv_null;
  }
  index = refTable[objId];
  if (index >= length) {
    return vv_null;
  }
  objType = data[index++];
  if ((objType & LENGTH_MASK) < LENGTH_MASK) {
    objLength = objType & LENGTH_MASK;
  } else {
    let lenType = 0;
    let lenLength = 0;
    let lenValue = 0;
    if (index >= length) {
      return vv_null;
    }
    lenType = data[index++];
    if ((lenType & TYPE_MASK) !== vv_uint64) {
      return vv_null;
    }
    lenLength = 1 << (lenType & LENGTH_MASK);
    if (index >= length) {
      return vv_null;
    }
    const lenResult = read_integer_value(data, index, lenLength);
    if (lenResult === false) {
      return vv_null;
    }
    index += lenLength;
    lenValue = lenResult;
    objLength = lenValue;
  }
  switch (objType & TYPE_MASK) {
    case 0:
      if (vv_null === objType) {
        console.log('鼠标不会有这种情况');
        return null;
      }
      if (vv_bool_true === objType) {
        return true;
      }
      if (vv_bool_false === objType) {
        return false;
      }
      return null;
    case vv_int8:
    case vv_int16:
    case vv_int32:
    case vv_int64:
    case vv_uint8:
    case vv_uint16:
    case vv_uint32:
    case vv_uint64: {
      objLength = 1 << objLength;
      const value = read_integer_value(data, index, objLength);
      if (value !== false) {
        return value;
      }
      break;
    }
    case vv_array: {
      if (index + objLength * refElelen <= length) {
        const arr = [];
        let i = 0;
        for (; i < objLength; i++) {
          let valueindex = 0;
          const res = read_integer_value(data, index, refElelen);
          if (res === false) {
            break;
          }
          valueindex = res;
          index += refElelen;
          const vv: any = deserialize_variant(refTable, objCount, valueindex, data, length, refElelen);
          if (!vv) {
            break;
          }
          arr.push(vv);
        }
        if (i === objLength) {
          return arr;
        }
      }
      break;
    }
    case vv_data: {
      if (index + objLength <= length) {
        const res = data.slice(index, index + objLength);
        return res;
      }
      break;
    }
    case vv_string: {
      if (index + objLength <= length) {
        const res = data.slice(index, index + objLength);
        // @ts-ignore
        const text = new TextDecoder().decode(res);
        return text;
      }
      break;
    }
    case vv_dict: {
      if (index + 2 * objLength * refElelen <= length) {
        let i = 0;
        const v: Record<any, any> = {};
        for (; i < objLength; i++) {
          const keyIndex = index + i * refElelen;
          if (keyIndex > length) {
            break;
          }
          const keyId = read_integer_value(data, keyIndex, refElelen);
          if (keyId === false) {
            break;
          }
          const key = deserialize_variant(refTable, objCount, keyId, data, length, refElelen);
          if (key === undefined || key === false) {
            break;
          }
          if (typeof key !== 'string') {
            break;
          }
          let valueIndex = index + objLength * refElelen + i * refElelen;
          if (valueIndex > length) {
            break;
          }
          const valueId = read_integer_value(data, valueIndex, refElelen);
          if (valueId === false) {
            break;
          }
          valueIndex += refElelen;
          const value = deserialize_variant(refTable, objCount, valueId, data, length, refElelen);
          // console.log('value:', value);
          if (value === undefined || value === false) {
            break;
          }
          v[key] = value;
        }
        if (i === objLength) {
          return v;
        }
      }
      break;
    }
    case vv_float: {
      const res = data.slice(index, index + 5);
      const dataView = new DataView(res.buffer);
      const float32 = dataView.getFloat32(0, true);
      return float32;
    }
    case vv_double: {
      const res = data.slice(index, index + 9);
      const dataView = new DataView(res.buffer);
      const float64 = dataView.getFloat64(0, true);
      return float64;
    }
  }
}
/**
 * @description xcase的鼠标数据反序列化js实现
 * @doc https://iwiki.woa.com/p/4010642610
 * @param data
 */
export function xcVariantDeserialize(data: any) {
  console.log(Array.from(data));
  if (!data) {
    return null;
  }

  if (new TextDecoder().decode(data.slice(0, 8)) !== START_TEXT) {
    console.log(
      'layerData null new TextDecoder().decode(data.slice(0, 8)):',
      new TextDecoder().decode(data.slice(0, 8)),
    );
    return null;
  }

  const { length } = data;
  const trailer = data.subarray(length - 32);
  const objCount = read_integer_value(trailer, 8, 8);
  const root_obj_id = read_integer_value(trailer, 16, 8);
  const ref_table_offset = read_integer_value(trailer, 24, 8);
  const offset_ele_len = trailer[6];
  const ref_ele_len = trailer[7];

  /** 这里原来的C代码是unit_64,这里如果用BigUnit64Array，会要求每个元素都是大数，不能保证解析的数据都是大数，所以用array替代 */
  const refTable = new Array(14);

  if (objCount === false || ref_table_offset === false || root_obj_id === false) {
    console.log('layerData null objCount === false || ref_table_offset === false || root_obj_id === false:');
    return null;
  }

  if (objCount === 0 || root_obj_id >= objCount) {
    console.log('layerData null objCount === 0 || root_obj_id >= objCount:');
    return null;
  }

  if (ref_table_offset < 8 || ref_table_offset + objCount * offset_ele_len > length) {
    console.log('layerData null ref_table_offset < 8 || ref_table_offset + objCount * offset_ele_len > length:');
    return null;
  }

  for (let i = 0; i < objCount; i++) {
    refTable[i] = read_integer_value(data, ref_table_offset + i * offset_ele_len, offset_ele_len);
  }

  // @ts-ignore
  const v = deserialize_variant(refTable, objCount, root_obj_id, data, length, ref_ele_len);
  // console.log('layerData vresult:', v);
  return v;
}

// 缓存鼠标图片数据
let mouseImageData: any = null;
let mouseWidth = 0;
let mouseHeight = 0;

export const clearMouseImageData = () => {
  mouseImageData = null;
};
interface DrawMouseParams {
  mouseInfo: {
    imgs: {
      data: Uint8Array;
      ch: number;
      cw: number;
      h: number;
      w: number;
      l: number;
      t: number;
      v: boolean;
      bm: number;
    }[];
  };
  id: string;
}

export const drawMouse = ({ mouseInfo, id }: DrawMouseParams) => {
  if (!mouseInfo) return;
  const canvas = document.getElementById(id) as HTMLCanvasElement;

  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const { imgs } = mouseInfo;

  if (!ctx) {
    return;
  }
  // 清空画布
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // 绘制鼠标
  for (let i = 0; i < imgs.length; i++) {
    const img = imgs[i];
    const { data } = img;
    const { ch } = img;
    const { cw } = img;
    const { h } = img;
    const { w } = img;
    const { v } = img;
    const { l } = img;
    const { t } = img;
    const { bm } = img;

    if (v) {
      console.log('w:', w);
      console.log('h:', h);
      console.log('data:', data);
      console.log('mouseImageData:', mouseImageData);
      console.log('mouseWidth:', mouseWidth);
      console.log('mouseHeight:', mouseHeight);
      console.log('!mouseImageData && !data:', !mouseImageData && !data);
      console.log('(!w && !mouseWidth) || (!h && !mouseHeight):', (!w && !mouseWidth) || (!h && !mouseHeight));
      if (!mouseImageData && !data && ((!w && !mouseWidth) || (!h && !mouseHeight))) {
        return;
      }
      if (w) {
        mouseWidth = w;
      }
      if (h) {
        mouseHeight = h;
      }

      if (!mouseImageData) {
        // 如果鼠标图案不存在，则创建一个新的 ImageData 对象
        mouseImageData = ctx.createImageData(mouseWidth, mouseHeight);
        const pixels = mouseImageData.data;

        // 将 uint8Array 转换为像素数组
        for (let j = 0; j < data.length; j += 4) {
          const alpha = data[j + 3];
          const index = j / 4;
          pixels[index * 4] = data[j];
          pixels[index * 4 + 1] = data[j + 1];
          pixels[index * 4 + 2] = data[j + 2];
          pixels[index * 4 + 3] = alpha;
        }
      }

      // 计算鼠标在画布上的位置和大小
      // const ratio = Math.min(160 / cw, 90 / ch);
      const x = Math.round((l * canvas.width) / cw);
      const y = Math.round((t * canvas.height) / ch);
      // const width = (canvas.width * w) / cw;
      // const height = (canvas.height * h) / ch;
      // 绘制鼠标
      if (bm === 9) {
        ctx.globalCompositeOperation = 'xor';
        ctx.drawImage(canvas, x, y);
        ctx.putImageData(mouseImageData, x, y);
        ctx.globalCompositeOperation = 'source-over';
      } else {
        ctx.putImageData(mouseImageData, x, y);
      }
    }
  }
};
